import {computed, Injectable, signal} from '@angular/core';
import {ShortcutPlatform} from './shortcut.model';

@Injectable({ providedIn: 'root' })
export class ShortcutService {
	readonly platform = signal<ShortcutPlatform>(this.detect());

	private detect(): ShortcutPlatform {
		const ua = navigator.userAgent.toLowerCase();

		if (/iphone|ipad|android/.test(ua)) return 'MOBILE';
		if (/mac/.test(ua)) return 'MAC';
		if (/win/.test(ua)) return 'WIN';
		return 'LINUX';
	}

	readonly modifierKey = computed(() =>
		this.platform() === 'MAC' ? '⌘' : 'Ctrl'
	);
}
